<template>
  <div class="column-progress-bar">
    <span class="-px cp-bar" :style="cpBarStyle">
      <span class="cp-in" :style="cpInStyle"></span>
    </span>
    <label v-if="!isNumber">
      {{ per }}
      <span class="font-small">%</span>
    </label>
    <label v-else>{{ number }}</label>
  </div>
</template>
<script>
  export default {
    props: {
      isNumber: {
        type: Boolean,
        default: true,
      },
      number: {
        type: Number,
        default: 0,
      },
      sumPercent: {
        type: Number,
        default: 0,
      },
      width: {
        type: String,
        default: '100px',
      },
    },
    computed: {
      cpInStyle() {
        return {
          width: this.sumPercent * 100 + '%',
        }
      },
      cpBarStyle() {
        return {
          width: this.width,
        }
      },
      per() {
        return parseFloat((this.sumPercent * 100).toPrecision(2))
      },
    },
    data() {
      return {}
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .column-progress-bar {
    display: inline-block;
    color: #80a9c0;
    label {
      height: 20px;
      line-height: 20px;
      display: inline-block;
      padding-left: 10px;
      vertical-align: middle;
      font-size: 16px;
      min-width: 60px;
      .font-small {
        font-size: 12px;
      }
    }

    .cp-bar {
      border: 1px solid #cfe1e2;
      width: 100px;
      //height: 30px;
      display: inline-block;
      position: relative;
      vertical-align: middle;
      border-radius: 3px;
      padding: 2px;
      line-height: 0;
      text-align: left;
      .cp-in {
        display: inline-block;
        height: 24px;
        background: #91bac9;
        width: 30px;
        border-radius: 3px;
      }
    }
    .-px.cp-bar {
      padding: 2px;
    }
  }
</style>
